module.exports = __webpack_public_path__ + "static/media/boss_gym_think.36fc214a.png";